<template>
    <div class="absolute h-full left-0 select-text top-0 w-full"
         v-on:mouseleave="hover = null">
        <div class="absolute h-full w-full">
            <div class="absolute side-container
                        bottom-[5%] left-[5%] right-[5%] top-[5%]"
                 ref="container"
                 v-bind:class="{ 'flipped': flipped, }">
                <template v-if="mounted"
                          v-for="(element, index) in sideElements">
                    <drr v-bind:class="{
                             'pointer-events-none': active === index,
                         }"
                         v-bind:style="{
                             outlineColor: (element.value && element.value.color ? element.value.color : 'inherit'),
                             zIndex: ((selected === index ? 2000 : 1000) + (element.zIndex * 1) + 2),
                         }"
                         v-if="editable &&
                               element &&
                               element.side === side &&
                               (!element.language || !language || element.language === language) &&
                               drr(index)"

                         v-bind:key="getRef(index)"
                         v-bind:ref="getRef(index)"

                         v-bind:aspect-ratio="element.preserve_aspect_ratio"
                         v-bind:has-active-content="element.has_active_content"

                         v-bind:angle="getInitial(element, 'angle')"
                         v-bind:h="getInitial(element, 'h')"
                         v-bind:w="getInitial(element, 'w')"
                         v-bind:x="getInitial(element, 'x')"
                         v-bind:y="getInitial(element, 'y')"
                         v-bind:max-h="getMax(element, 'h')"
                         v-bind:max-w="getMax(element, 'w')"

                         v-on:clicked="e => clicked(index, e)"
                         v-on:content-active="contentActivated(index)"
                         v-on:deselect="deselect(index)"
                         v-on:drag="(rect) => { change(index, rect) }"
                         v-on:dragstart="dragStart"
                         v-on:dragstop="dragEnd"
                         v-on:rotate="(rect) => { change(index, rect) }"
                         v-on:rotatestart="dragStart"
                         v-on:rotatestop="dragEnd"
                         v-on:resize="(rect) => { change(index, rect); }"
                         v-on:select="select(index)"
                         v-on:mouseover="hover = index"
                    >
                        <div class="absolute flex flex-col gap-2 left-full mx-2 top-0"
                             v-bind:style="{
                             zIndex: (11000 + (element.zIndex * 1) + 2),
                         }"
                             v-if="(selected === null && hover === index) ||
                                   selected === index"
                             v-show="!dragging">
                            <button class="bg-white flex justify-center items-center h-8 rounded-full w-8
                                       transition-all duration-200 ease-in-out
                                       hover:-translate-y-1"
                                    v-on:mousedown="deleteElement(index)"
                                    v-on:touchstart="deleteElement(index)">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                     stroke-width="1.5"
                                     stroke="currentColor"
                                     class="text-red-700 w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                          d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"/>
                                </svg>
                            </button>
                            <button class="bg-white flex justify-center items-center h-8 rounded-full w-8
                                       transition-all duration-200 ease-in-out
                                       hover:-translate-y-1"
                                    v-on:mousedown="duplicateElement(index, true)"
                                    v-on:touchstart="duplicateElement(index, true)">
                                <svg data-v-d4e6e290="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                     fill="none"
                                     stroke-width="1" stroke="currentColor"
                                     class="w-6 h-6">
                                    <path data-v-d4e6e290="" stroke-linecap="round" stroke-linejoin="round"
                                          d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"></path>
                                </svg>
                            </button>
                        </div>
                        <div class="absolute my-10 flex flex-col"
                             v-bind:style="{
                                     zIndex: (22000 + (element.zIndex * 1) + 2),
                                 }"
                             v-bind:class="{
                                 'bottom-full': drrControlsPosition(index) === 'top',
                                 'top-full': drrControlsPosition(index) === 'bottom',
                             }"
                             v-bind:id="'controls-drr-' + side + '-' + index"
                             v-bind:ref="'controls-drr-' + side + '-' + index"
                             v-on:mousedown.stop="() => {}"
                             v-show="!dragging"
                        >
                        </div>
                    </drr>
                    <div class="absolute pointer-events-none"
                         v-else-if="element && element.component === 'image-area'"
                         v-bind:style="{
                             ...getStaticStyle(element, true),
                             overflow: 'visible',
                             zIndex: ((active === index || selected === index ? 2000 : 1000) + (element.zIndex * 1) + 2),
                         }">
                        <div class="absolute my-10 flex flex-col pointer-events-auto"
                             v-bind:style="{
                                 zIndex: (22000 + (element.zIndex * 1) + 2),
                             }"
                             v-bind:class="{
                                 'bottom-full': drrControlsPosition(index) === 'top',
                                 'top-full': drrControlsPosition(index) === 'bottom',
                             }"
                             v-bind:id="'controls-drr-' + side + '-' + index"
                             v-bind:ref="'controls-drr-' + side + '-' + index"
                             v-on:mousedown.stop="() => {}"
                             v-show="!dragging"
                        >
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="absolute h-full pointer-events-none w-full"
             v-bind:class="{
                 'overflow-hidden': active !== index || !editable,
             }"
             v-bind:style="{
                 zIndex: (element.zIndex * 1) + 2,
             }"
             v-for="(element, index) in sideElements"
             v-if="mounted &&
                   element &&
                   element.side === side &&
                   (!element.language || !language || element.language === language) &&
                   checkForUuid(index)">
            <div class="absolute side-container
                        bottom-[5%] left-[5%] right-[5%] top-[5%]"
                 v-bind:class="{
                     'flipped': flipped,
                 }">
                <div class="absolute pointer-events-auto"
                     v-bind:id="'element-' + index"
                     v-bind:style="getStaticStyle(element, true)"

                     v-bind:key="getRef(index, '_static')"
                     v-bind:ref="getRef(index, '_static')">
                    <component v-bind:always-active="elementIsAlwaysActive(element)"
                               v-bind:editable="editable"
                               v-bind:edit-mode="editMode"
                               v-bind:enable-delete="enableDelete"
                               v-bind:enable-images="enableImages"
                               v-bind:enable-stickers="enableStickers"
                               v-bind:enable-textareas="enableTextareas"
                               v-bind:enable-texts="enableTexts"
                               v-bind:enable-z-indexes="enableZIndexes"
                               v-bind:has-active-content="element.has_active_content"
                               v-bind:index="index"
                               v-bind:is="'vcs-new-2d-model-side-component-' + element.component"
                               v-bind:point-size="fontPointSize"
                               v-bind:ref="getRef(index, '_static_component')"
                               v-bind:side="side"
                               v-model="element.value"
                               v-on:delete="() => deleteElement(index)"
                               v-on:change-ratio="(ratio) => changeRatio(index, ratio)"
                               v-on:change-size="(width, height) => changeSize(index, width, height)"
                               v-on:content-active="contentActivated(index)"
                               v-on:content-inactive="contentDeactivated(index)"
                               v-on:set-state="(value) => setState(value, true)"></component>
                </div>
            </div>
        </div>
        <slot name="side"
              v-bind:font-point-size="fontPointSize"></slot>
        <Teleport to="#side-controls-out"
                  v-if="editable"
                  where="before">
            <button class="flex flex-col gap-x-1 gap-x-[5px] items-center whitespace-nowrap
                           font-bold text-[12px]
                           lg:flex-row lg:text-2xl"
                    v-if="enableTexts"
                    v-on:click="createTextElement">
                <!--                <img alt=""
                                     class="h-[30px]"
                                     src="/img/editor-001/icon-text.png">-->

                <span class="bg-neutral-900/80 p-2 rounded-full text-white">
                    <svg class="h-6 text-white"
                         stroke="currentColor"
                         viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path
                            d="M12 18L8 5H7L3 18M4.23077 14H10.7692M14.5 10C16 9 20 8 20 11.5C20 15 20 18 20 18M20 12.5C18.5 13 14 13 14 16C14 19 18.5 18 20 15.5"
                            fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
                <span class="overflow-hidden h-0 w-0 lg:h-auto lg:w-auto">Add text</span>
            </button>
        </Teleport>
        <Teleport to="#side-controls-out"
                  v-if="editable"
                  where="after">
            <label class="cursor-pointer flex flex-col gap-x-1 gap-x-[5px]] items-center whitespace-nowrap
                          font-bold text-[12px]
                          lg:flex-row lg:text-2xl"
                   for="image_upload">
                <!--                <img alt=""
                                     class="h-[30px]"
                                     src="/img/editor-001/icon-image.png">-->
                <span class="bg-neutral-900/80 p-2 rounded-full text-white">
                    <svg class="h-6 text-white"
                         stroke="currentColor"
                         viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path
                            d="M8 11C9.10457 11 10 10.1046 10 9C10 7.89543 9.10457 7 8 7C6.89543 7 6 7.89543 6 9C6 10.1046 6.89543 11 8 11Z"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            fill="none"/>
                        <path
                            d="M18 3H6C3.79086 3 2 4.79086 2 7V17C2 19.2091 3.79086 21 6 21H18C20.2091 21 22 19.2091 22 17V7C22 4.79086 20.2091 3 18 3Z"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            fill="none"/>
                        <path d="M6.56055 21C12.1305 8.89998 16.7605 6.77998 22.0005 14.63" stroke="currentColor"
                              fill="none"
                              stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
                <span class="overflow-hidden h-0 w-0 lg:h-auto lg:w-auto">Add image</span>
            </label>
            <button class="flex flex-col gap-x-1 gap-x-[5px] items-center whitespace-nowrap
                           font-bold text-[12px]
                           lg:flex-row lg:text-2xl"
                    v-if="editMode === 'designer'"
                    v-on:click="createActiveElement('image-area', true, null, { zIndex: -2 })">
                <img alt=""
                     class="h-[30px]"
                     src="img/editor-001/icon-image.png">
                <span class="overflow-hidden h-0 w-0 lg:h-auto lg:w-auto">Add image area</span>
            </button>
            <button class="flex flex-col gap-x-1 gap-x-[5px] items-center whitespace-nowrap
                           font-bold text-[12px]
                           lg:flex-row lg:text-2xl"
                    v-on:click="() => $refs['stickers-modal'].openModal()">
                <!--                <img alt=""
                                     class="h-[30px]"
                                     src="/img/editor-001/icon-image.png">-->
                <span class="bg-neutral-900/80 p-2 rounded-full text-white">
                    <svg class="h-6 text-white rotate-[-15deg]"
                         fill="currentColor"
                         stroke="currentColor"
                         viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path d="M9 16C9.85038 16.6303 10.8846 17 12 17C13.1154 17 14.1496 16.6303 15 16"
                              stroke="currentcolor" stroke-width="1.5" stroke-linecap="round"/>
                        <ellipse cx="15" cy="10.5" rx="1" ry="1.5" fill="none"/>
                        <ellipse cx="9" cy="10.5" rx="1" ry="1.5" fill="none"/>
                        <path
                            d="M15 22H12C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C21.5093 4.43821 21.8356 5.80655 21.9449 8M15 22C18.866 22 22 18.866 22 15M15 22C15 20.1387 15 19.2081 15.2447 18.4549C15.7393 16.9327 16.9327 15.7393 18.4549 15.2447C19.2081 15 20.1387 15 22 15M22 12V15"
                            stroke="currentColor" fill="none" stroke-width="2" stroke-linecap="round"/>

                    </svg>
                </span>
                <span class="overflow-hidden h-0 w-0 lg:h-auto lg:w-auto">Add sticker</span>
            </button>
            <button class="flex flex-col gap-x-1 gap-x-[5px] items-center whitespace-nowrap
                           font-bold text-[12px]
                           lg:flex-row lg:text-2xl"
                    v-on:click="() => $refs['textareas-modal'].openModal()">
                <!--                <img alt=""
                                     class="h-[30px]"
                                     src="/img/editor-001/icon-text.png">-->

                <span class="bg-neutral-900/80 p-2 rounded-full text-white">
                    <svg class="h-6 text-white"
                         fill="currentColor"
                         stroke="currentColor"
                         viewBox="0 0 45.73 45.73" version="1.1" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g>
                                <g stroke-width="1">
                                    <path d="M39.74,17.128c-0.308,0.182-0.631,0.338-0.979,0.437c-0.367,0.104-0.747,0.155-1.128,0.155
                                        c-0.294,0-0.582-0.041-0.865-0.101l3.414,15.229c0.209,0.928,0.043,1.883-0.467,2.686c-0.511,0.805-1.302,1.363-2.23,1.57
                                        l-24.675,5.533c-0.918,0.206-1.893,0.035-2.686-0.468c-0.804-0.511-1.362-1.302-1.569-2.229L4.023,19.724
                                        c-0.43-1.917,0.78-3.826,2.697-4.256l20.833-4.671c-0.054-0.178-0.101-0.358-0.128-0.544c-0.137-0.908,0.039-1.824,0.473-2.616
                                        L6.062,12.533c-3.535,0.792-5.767,4.313-4.974,7.849L5.62,40.597c0.384,1.714,1.412,3.173,2.894,4.112
                                        c1.054,0.669,2.271,1.021,3.52,1.021c0.481,0,0.965-0.054,1.436-0.158l24.675-5.533c1.713-0.385,3.173-1.412,4.113-2.895
                                        c0.938-1.481,1.245-3.242,0.86-4.955L39.74,17.128z"/>
                                    <path d="M41.04,1.58C39.42,0.536,37.711,0,36.327,0c-1.13,0-2.044,0.358-2.515,1.088c-0.583,0.907-0.364,2.196,0.456,3.487
                                        l-3.616,4.321c-0.211,0.253-0.304,0.584-0.255,0.911c0.051,0.324,0.237,0.614,0.514,0.792l1.411,0.909l-2.19,4.901
                                        c-0.199,0.447-0.1,0.989,0.288,1.331c0.219,0.194,0.489,0.289,0.761,0.289c0.317,0,0.636-0.132,0.863-0.389l3.557-4.022
                                        l1.411,0.911c0.187,0.12,0.402,0.182,0.622,0.182c0.104,0,0.209-0.014,0.312-0.043c0.317-0.089,0.579-0.312,0.725-0.607
                                        l2.438-5.078c0.294,0.041,0.578,0.062,0.852,0.062c1.13,0,2.043-0.357,2.514-1.088C45.521,6.332,43.983,3.477,41.04,1.58z"/>
                                </g>
                            </g>
                        </svg>
                    </span>
                <span class="overflow-hidden h-0 w-0 lg:h-auto lg:w-auto">Add textarea</span>
            </button>
        </Teleport>
        <input accept="image/*"
               class="hidden"
               id="image_upload"
               type="file"
               v-on:change="createImageElement">
        <vcs-modal modal-width="sm:w-full sm:max-w-4xl"
                   ref="textareas-modal"
                   v-if="editable">
            <template v-slot:main="main"></template>
            <template v-slot:modal="modal">
                <vcs-new-textareas
                    v-bind:format="format"
                    v-if="modal.showModal"
                    v-on:create-element="(component, add, value, config) => { createActiveElement(component, add, value, config); modal.closeModal(); }"
                ></vcs-new-textareas>
            </template>
        </vcs-modal>
        <vcs-modal modal-width="sm:w-full sm:max-w-4xl"
                   ref="stickers-modal"
                   v-if="editable">
            <template v-slot:main="main"></template>
            <template v-slot:modal="modal">
                <vcs-new-stickers-giphy
                    v-on:create-element="(component, add, value, config) => { createElement(component, add, value, config); modal.closeModal(); }"
                    v-if="modal.showModal"
                ></vcs-new-stickers-giphy>
            </template>
        </vcs-modal>
        <input class="h-0 w-0 opacity-0"
               ref="input"
               v-if="editable"
               v-on:keydown="hiddenInputKeydown">
    </div>
</template>
<script>
// Import draggable
import drr from './drr.vue';

import Teleport from 'vue2-teleport';

export default {
    name: "vcs-new-2d-model-side",
    components: {
        Teleport,
        drr,
    },
    computed: {
        fontPointSize: function () {
            // a5 landscape
            var areaHeightPx = 1748;
            if (this.format === 'a5-portrait')
                areaHeightPx = 2480;
            var pointSizePerc = 100 * (300 / 72) / areaHeightPx;
            var pointSizePx = this.sideHeight / 100 * pointSizePerc;
            return pointSizePx;
        },
    },
    data: function () {
        return {
            active: null,
            clickedTimeout: null,
            dragging: false,
            draggingTimeout: null,
            hover: null,
            shift: false,
            sideElements: [],
            sideHeight: null,
            sideWidth: null,
            mounted: false,
            selected: null,
            state: null,
            resizeScreenTimeout: null,
        };
    },
    methods: {
        activateElement: function (index) {
            if (this.$refs['input'])
                this.$refs['input'].focus();

            if (!this.$refs[this.getRef(index, '_static_component')] ||
                !this.$refs[this.getRef(index, '_static_component')][0])
                return setTimeout(() => {
                    this.activateElement(index);
                }, 10);

            this.$refs[this.getRef(index)][0].dblclick();
            this.$forceUpdate();
        },
        addElement: function (element, activate = true) {
            // Add side
            element.side = this.side;

            // Add element
            var index = this.sideElements.push(element);
            index--;

            // Activate element
            if (element.has_active_content &&
                activate) {
                this.activateElement(index);
            }

            // Return the index
            return index;
        },
        change: function (index, rect) {
            if (typeof this.$refs[this.getRef(index)] === 'undefined' ||
                typeof this.$refs[this.getRef(index)][0] === 'undefined')
                return;

            // Clear clicked timeout
            this.clickedClear();

            // Retrieve side sizes
            var sideHeight = this.$refs.container.offsetHeight;
            var sideWidth = this.$refs.container.offsetWidth;

            // Calculate position in %
            this.sideElements[index].angle = rect.angle;
            this.sideElements[index].left = (100 / sideWidth * rect.x);
            this.sideElements[index].ratio = rect.w / rect.h;
            this.sideElements[index].top = (100 / sideHeight * rect.y);
            this.sideElements[index].width = (100 / sideWidth * rect.w);

            if (typeof this.$refs[this.getRef(index)][0].$children[0] !== 'undefined' &&
                typeof this.$refs[this.getRef(index)][0].$children[0].emitSize === 'function')
                this.$refs[this.getRef(index)][0].$children[0].emitSize();

            if (this.$refs[this.getRef(index, '_static_component')] &&
                typeof this.$refs[this.getRef(index, '_static_component')][0] !== 'undefined' &&
                typeof this.$refs[this.getRef(index, '_static_component')][0].resize === 'function')
                this.$refs[this.getRef(index, '_static_component')][0].resize(rect);
        },
        changeRatio: function (index, ratio) {
            if (typeof this.$refs[this.getRef(index)] === 'undefined' ||
                typeof this.$refs[this.getRef(index)][0] === 'undefined')
                return;

            this.sideElements[index].ratio = ratio;

            if (typeof this.$refs[this.getRef(index)][0].$children !== 'undefined' &&
                typeof this.$refs[this.getRef(index)][0].$children[0] !== 'undefined' &&
                typeof this.$refs[this.getRef(index)][0].$children[0].emitSize === 'function')
                this.$refs[this.getRef(index)][0].$children[0].emitSize();
        },
        changeSize: function (index, width, height) {
            if ((!height && !width) ||
                typeof this.$refs[this.getRef(index)] === 'undefined' ||
                typeof this.$refs[this.getRef(index)][0] === 'undefined')
                return;

            // Retrieve side sizes
            var sideHeight = this.$refs.container.offsetHeight;
            var sideWidth = this.$refs.container.offsetWidth;

            // Calculate position in %
            this.sideElements[index].ratio = width / height;
            this.sideElements[index].height = Math.round(100 / sideHeight * height);
            this.sideElements[index].width = Math.round(100 / sideWidth * width);

            if (this.active !== index)
                return;

            const xBoundLimit = (100 - (100 / 0.9)) / 2;

            if (this.sideElements[index].width > 100 - 2 * xBoundLimit &&
                typeof this.$refs[this.getRef(index, '_static_component')][0].reduceWidth === 'function')
                return this.$refs[this.getRef(index, '_static_component')][0].reduceWidth();

            const leftBound = this.sideElements[index].left - (this.sideElements[index].width / 2);
            if (leftBound <= xBoundLimit)
                this.sideElements[index].left = (this.sideElements[index].width / 2) + xBoundLimit;

            const rightBound = this.sideElements[index].left + (this.sideElements[index].width / 2);
            if (rightBound >= 100 - xBoundLimit)
                this.sideElements[index].left = (100 - (this.sideElements[index].width / 2)) - xBoundLimit;

        },
        checkForUuid: function (index) {
            if (!this.sideElements[index].uuid)
                this.sideElements[index].uuid = this.generateUuid();
            return true;
        },
        clicked: function (index, e) {
            if (e.touches &&
                this.selected !== null &&
                this.selected === index &&
                this.clickedTimeout !== null &&
                this.$refs[this.getRef(index, '_static_component')] &&
                this.$refs[this.getRef(index, '_static_component')][0] &&
                this.$refs[this.getRef(index, '_static_component')][0].focus) {
                this.$refs[this.getRef(index)][0].dblclick();
                this.$refs[this.getRef(index, '_static_component')][0].focus();
                return;
            }

            // Activate on first click if no drr
            if (!this.drr(index))
                return this.$refs[this.getRef(index)][0].dblclick();

            // Check for second click
            this.clickedTimeout = setTimeout(this.clickedClear, 500);
        },
        clickedClear: function () {
            if (!this.clickedTimeout)
                return;

            clearTimeout(this.clickedTimeout);
            this.clickedTimeout = null;
        },
        contentActivated: function (index) {
            if (this.active === index)
                return;

            if (this.active !== null)
                this.contentDeactivated(this.active);
            if (this.selected !== null &&
                this.selected !== index)
                this.deselect(this.selected);

            if (this.$refs['input'])
                this.$refs['input'].focus();

            this.active = index;
            this.selected = index;
            if (this.$refs[this.getRef(index, '_static_component')] &&
                this.$refs[this.getRef(index, '_static_component')][0] &&
                this.$refs[this.getRef(index, '_static_component')][0].activated)
                this.$refs[this.getRef(index, '_static_component')][0].activated();
        },
        contentDeactivated: function (index) {
            if (this.active !== index)
                return;

            if (this.$refs[this.getRef(index)] &&
                this.$refs[this.getRef(index)][0] &&
                this.$refs[this.getRef(index)][0].onContentInactive)
                this.$refs[this.getRef(index)][0].onContentInactive();

            this.active = null;
        },
        createActiveElement: function (component, add = true, value = null, config = {}) {
            var element = this.createElement(component, false, value, config);
            element.has_active_content = true;
            if (add)
                return this.addElement(element, false);

            return element;
        },
        createElement: function (component, add = true, value = null, config = {}) {
            var element = {
                uuid: this.generateUuid(),

                language: this.language,

                has_active_content: false,
                preserve_aspect_ratio: false,

                angle: 0,
                left: 50,
                ratio: 1,
                top: 50,
                width: (component === 'text' ? 0 : 20),
                zIndex: this.zIndex(),

                component: component,
                value: value,
            };

            if (value &&
                value.ratio)
                element.ratio = value.ratio;

            // Apply max width
            if (config.max_width) {
                const maxWidth = (100 / (100 * 0.9) * 100) / (this.format.includes('landscape') ? 6000 : 4383) * config.max_width;
                if (element.width > maxWidth)
                    element.width = maxWidth;
            }
            // Apply max height
            if (config.max_height) {
                const maxHeight = (100 / (100 * 0.9) * 100) / (this.format.includes('landscape') ? 6000 : 4383) * config.max_height;
                if (element.height > maxHeight)
                    element.height = maxHeight;
            }


            for (let key in config)
                element[key] = config[key];

            // Create and return index
            if (add)
                return this.addElement(element);

            // Return element
            return element;
        },
        createImageElement: function (e) {
            // Get file
            var file = e.target.files[0];

            // Load file locally
            var fr = new FileReader();
            fr.onload = () => {
                // Create image
                var image = new Image();
                image.onload = () => {
                    const maxWidth = (100 / (100 * 0.9) * 100) / (this.format.includes('landscape') ? 6000 : 4383) * image.width;
                    let width = maxWidth;
                    if (width > 50)
                        width = 50;

                    // Create element
                    var element = this.createElement('image', false, {
                        src: URL.createObjectURL(file),
                        type: 'image',
                    }, {
                        max_width: image.width * 20,
                        preserve_aspect_ratio: true,
                        ratio: image.width / image.height,
                        width: width,
                    });

                    // Add element
                    var elementIndex = this.addElement(element);

                    // Upload file
                    var formData = new FormData();
                    formData.append('file', file);
                    this.axios.post('/api/image/upload',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    ).then((response) => {
                        // Replace src url
                        var image = new Image();
                        image.onload = () => {
                            setTimeout(() => {
                                this.sideElements[elementIndex].value.src = response.data;
                            }, 100);
                        };
                        image.src = response.data;
                    });

                };
                image.src = fr.result;
            }
            fr.readAsDataURL(file);
        },
        createTextElement: function () {
            let color = '#000000';
            let fontFamily = 'PT Sans';

            for (let key in this.sideElements)
                if (this.sideElements[key] &&
                    this.sideElements[key].component === 'text' &&
                    this.sideElements[key].value &&
                    this.sideElements[key].value.color &&
                    this.sideElements[key].value.fontFamily) {
                    color = this.sideElements[key].value.color;
                    fontFamily = this.sideElements[key].value.fontFamily;
                    break;
                }

            this.createActiveElement('text', true, {
                lineHeight: 1.15,
                size: 35,
                value: '<span style="color: ' + color + '; font-family: ' + fontFamily + ';">Double click to edit</span>',
            }, {
                preserve_aspect_ratio: true,
            });
        },
        copyElementsFrom: function (fromLanguage) {
            if (fromLanguage === this.language)
                return;

            // Copy elements
            for (var key in this.sideElements)
                if (this.sideElements[key] &&
                    this.sideElements[key].side === this.side &&
                    this.sideElements[key].language === fromLanguage) {
                    var element = JSON.parse(JSON.stringify(this.sideElements[key]));
                    element.language = this.language;
                    element.uuid = this.generateUuid();
                    this.addElement(element);
                }
        },
        deleteElement: function (index) {
            // Deactivate
            this.active = null;

            // Deselect
            this.$refs[this.getRef(index)][0].deselect();

            // Delete
            this.$set(this.sideElements, index, null);

            // Organize z-indexes
            this.zIndexesFix();
        },
        deselect: function (index) {
            if (this.selected !== index)
                return;

            this.clickedClear();
            this.$set(this, 'selected', null);

            if (this.$refs[this.getRef(index, '_static_component')] &&
                this.$refs[this.getRef(index, '_static_component')][0] &&
                this.$refs[this.getRef(index, '_static_component')][0].deselect)
                this.$refs[this.getRef(index, '_static_component')][0].deselect();

            this.$refs[this.getRef(index)][0].active = false;
            this.hover = null;
        },
        dragEnd: function () {
            if (this.draggingTimeout) {
                clearTimeout(this.draggingTimeout);
                this.draggingTimeout = null;
            }
            this.dragging = false;
        },
        dragStart: function () {
            if (this.draggingTimeout) {
                clearTimeout(this.draggingTimeout);
                this.draggingTimeout = null;
            }
            this.draggingTimeout = setTimeout(() => {
                this.dragging = true;
            }, 10)
        },
        duplicateElement: function (index, relativePosition = false) {
            // Remove explainer
            if (this.sideElements[index].explainer)
                this.sideElements[index].explainer = null;

            // Deselect current
            this.$refs[this.getRef(index)][0].deselect();

            // Create clone
            var clone = JSON.parse(JSON.stringify(this.sideElements[index]));

            // Remove uuid
            clone.uuid = null;

            // Fox z-index
            clone.zIndex = this.zIndex();

            // Move clone
            clone.left = 50;
            clone.top = 50;
            if (relativePosition) {
                clone.left = this.sideElements[index].left + 5;
                clone.top = this.sideElements[index].top + 5;
            }

            // Add clone
            this.addElement(clone);
        },
        drr: function (index) {
            if (this.editMode === 'user' &&
                this.sideElements[index].component === 'image-area')
                return false;

            return true;
        },
        drrControlsPosition: function (index) {
            const top = this.getInitial(this.sideElements[index], 'y') - this.getInitial(this.sideElements[index], 'h') / 2;

            // Calculate height of drr bar
            const drrControls = this.$refs['controls-drr-' + this.side + '-' + index];
            if (!drrControls)
                return 'top';

            // if (drrControls[0].clientHeight > top)
            if (top < 0)
                return 'bottom';

            return 'top';
        },
        elementButtonsClasses: function (element) {
            return {
                'left-full': element.left + element.width / 2 < 95,
                'right-full': element.left + element.width / 2 >= 95,
                'top-0': element.top - (element.width / element.ratio) / 2 >= 0,
                'bottom-0': element.top - (element.width / element.ratio) / 2 < 0,
            };
        },
        elementIsAlwaysActive: function (element) {
            return false;
        },
        generateUuid: function uuidv4() {
            return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },
        getExplainStyle: function (index) {
            if (!this.$refs[this.getRef(index, '_static')] ||
                !this.$refs[this.getRef(index, '_static')][0])
                return {};

            let arrow = this.$refs[this.getRef(index, '_arrow')][0];
            let arrowHeight = arrow.offsetHeight;
            let explainer = this.$refs[this.getRef(index, '_explainer')][0]
            let element = this.$refs[this.getRef(index, '_static')][0];
            let elementRect = element.getBoundingClientRect();
            let textHeight = explainer.querySelector('p').offsetHeight;

            let left = elementRect.right + 20;
            let top = elementRect.y - arrowHeight + 20;
            if (top < textHeight)
                top = textHeight;

            return {
                left: left + 'px',
                top: top + 'px', // - image height
            };
        },
        getInitial: function (element, field) {
            // Get side bounds
            var side = this.$refs.container;

            let value = 100;
            if (!side)
                return value;

            // Return options
            if (field === 'angle')
                value = element.angle;
            if (field === 'h')
                value = (side.offsetWidth / 100 * element.width) / element.ratio;
            if (field === 'w')
                value = (side.offsetWidth / 100 * element.width);
            if (field === 'x')
                value = (side.offsetWidth / 100 * element.left);
            if (field === 'y')
                value = (side.offsetHeight / 100 * element.top);

            if ((field === 'h' ||
                    field === 'w') &&
                !value)
                return 0.01;

            return value;
        },
        getMax: function (element, field) {
            var side = this.$refs.container;
            if (!side)
                return null;

            const sideWidthPx = this.format.includes('landscape') ? 6000 : 4383;
            const sideHeightPx = this.format.includes('landscape') ? 4383 : 6000;

            if (field === 'w' &&
                element.max_width)
                return side.offsetWidth / 100 * (100 / sideWidthPx * element.max_width);
            if (field === 'h' &&
                element.max_height)
                return side.offsetHeight / 100 * (100 / sideHeightPx * element.max_height);

            return null;
        },
        getRef: function (index, append = '') {
            return 'ddr_' + index + append;
        },
        getStaticStyle: function (element, isStatic = false) {
            // Check if ref is available yet
            if (!isStatic &&
                (!this.mounted || this.editable))
                return {};

            // Get side bounds
            var side = this.$refs.container;

            // Init style
            var style = {};

            style.height = (side.offsetWidth / 100 * element.width) / element.ratio + 'px';
            style.left = (side.offsetWidth / 100 * element.left) + 'px';
            style.top = (side.offsetHeight / 100 * element.top) + 'px';
            style.width = (side.offsetWidth / 100 * element.width) + 'px';
            style.zIndex = element.zIndex + 2;

            style.transform = 'translateX(-50%) ' +
                'translateY(-50%) ' +
                'rotateZ(' + element.angle + 'deg) ';

            if (element.component === 'image-area')
                style.overflow = 'hidden';

            // Return style
            return style;
        },
        hiddenInputKeydown: function (e) {
            this.$refs[this.getRef(this.active, '_static_component')][0].focus()
        },
        keyDown: function (e) {
            // No action if nothing is selected
            if (this.selected === null)
                return;

            // No action here if something is active
            if (this.active)
                return;

            // Prevent if cmd or ctrl is down
            if (e.metaKey || e.ctrlKey)
                return;

            // Get keycode
            var keyCode = e.keyCode;

            // Detect shift key
            if (keyCode === 16)
                return this.keyDownShift(e);

            // Detect cursor keys
            if (keyCode >= 37 &&
                keyCode <= 40)
                return this.keyDownCursor(e);

            // Detect delete key and delete element
            if (keyCode === 8 ||
                keyCode === 46)
                return this.deleteElement(this.selected);

            if (!(keyCode >= 48 && keyCode <= 57) &&
                !(keyCode >= 65 && keyCode <= 90) &&
                !(keyCode >= 97 && keyCode <= 122))
                return;

            // Activate selected element
            if (this.$refs[this.getRef(this.selected)][0] &&
                this.$refs[this.getRef(this.selected)][0].hasActiveContent) {
                this.contentActivated(this.selected)
                this.$refs[this.getRef(this.selected)][0].onContentActive();
            }
            if (this.$refs[this.getRef(this.selected, '_static_component')][0] &&
                this.$refs[this.getRef(this.selected, '_static_component')][0].focus)
                this.$refs[this.getRef(this.selected, '_static_component')][0].focus(e.key);

            // setTimeout(() => {
            // Emit the key input
            // if (this.$refs[this.getRef(this.selected, '_static_component')][0].input)
            //     this.$refs[this.getRef(this.selected, '_static_component')][0].input(e.key);
            // }, 100);

            return true;
        },
        keyDownCursor: function (e) {
            // Prevent scroll
            e.preventDefault();

            // Get var %
            var move = 100 / this.$refs.container.clientHeight;
            if (this.shift)
                move *= 10;

            // Get keycode
            var keyCode = e.keyCode;

            if (keyCode === 37)
                this.sideElements[this.selected].left -= move;
            if (keyCode === 39)
                this.sideElements[this.selected].left += move;
            if (keyCode === 38)
                this.sideElements[this.selected].top -= move;
            if (keyCode === 40)
                this.sideElements[this.selected].top += move;
        },
        keyDownShift: function (e) {
            this.shift = true;
        },
        keyUp: function (e) {
            // Detect shift key
            if (e.keyCode === 16)
                return this.keyUpShift(e);
        },
        keyUpShift: function (e) {
            this.shift = false;
        },
        move: function (index, dir = -1) {
            // Can't move further back
            if (this.sideElements[index].zIndex + dir === -1)
                return;
            // Can't move further forward
            if (this.sideElements[index].zIndex + dir === this.sideElements.length)
                return;

            var currentZ = this.sideElements[index].zIndex;
            var newZ = currentZ + dir;

            for (var key in this.sideElements)
                if (this.sideElements[key] &&
                    this.sideElements[key].side === this.side &&
                    this.sideElements[key].zIndex === newZ) {
                    this.sideElements[key].zIndex -= dir;
                    this.sideElements[index].zIndex = newZ;
                    break;
                }
        },
        moveTo: function (index, newZ) {
            // Can't move further back
            if (newZ <= -1)
                return;
            // Can't move further forward
            if (newZ === this.sideElements.length)
                return;

            var currentZ = this.sideElements[index].zIndex;

            for (var key in this.sideElements)
                if (key !== index &&
                    this.sideElements[key] &&
                    this.sideElements[key].side === this.side &&
                    this.sideElements[key].zIndex >= 0)
                    if (this.sideElements[key].zIndex >= newZ && this.sideElements[key].zIndex <= currentZ)
                        this.sideElements[key].zIndex++;
                    else if (this.sideElements[key].zIndex >= currentZ && this.sideElements[key].zIndex <= newZ)
                        this.sideElements[key].zIndex--;

            this.sideElements[index].zIndex = newZ;
        },
        resizeScreen: function () {
            if (this.$refs.container)
                setTimeout(() => {
                    this.sideHeight = this.$refs.container.offsetHeight;
                    this.sideWidth = this.$refs.container.offsetWidth;
                }, 10)
        },
        select: function (index) {
            // Ignore if already selected
            if (this.selected === index)
                return;

            // Store selected index
            this.$set(this, 'selected', index);

            // Remove explainer
            if (this.sideElements[index].explainer)
                this.sideElements[index].explainer = null;

            // Close panels
            this.$set(this, 'state', null);

            if (this.$refs[this.getRef(index, '_static_component')] &&
                this.$refs[this.getRef(index, '_static_component')][0] &&
                this.$refs[this.getRef(index, '_static_component')][0].select)
                this.$refs[this.getRef(index, '_static_component')][0].select();

            // Deselect other sideElements
            for (var key in this.sideElements)
                if (key != index) {
                    if (this.$refs[this.getRef(key)] &&
                        this.$refs[this.getRef(key)][0] &&
                        this.$refs[this.getRef(key)][0].deselect)
                        this.$refs[this.getRef(key)][0].deselect();
                    if (this.$refs[this.getRef(key, '_static_component')] &&
                        this.$refs[this.getRef(key, '_static_component')][0] &&
                        this.$refs[this.getRef(key, '_static_component')][0].deselect)
                        this.$refs[this.getRef(key, '_static_component')][0].deselect();
                }

            if (this.sideElements[index].component !== 'image-area')
                this.sideElements[index].zIndex = this.zIndex();
            this.zIndexesFix();
        },
        setState: function (value, nullParent) {

            this.state = null;
            setTimeout(() => {
                this.state = value;
            }, 50);

            if (value || nullParent)
                this.$emit('clear-state');
        },
        toggleState: function (value) {

            this.$emit('clear-state');

            if (this.state === value)
                this.state = null;
            else {
                this.state = null;
                setTimeout(() => {
                    this.state = value;

                    if (this.selected !== null)
                        this.deselect(this.selected);
                }, 50);

            }
        },
        zIndex: function () {
            let elements = [];
            for (var key in this.sideElements)
                if (this.sideElements[key] !== null &&
                    this.sideElements[key].side === this.side &&
                    this.sideElements[key].language === this.language &&
                    this.sideElements[key].component !== 'image-area')
                    elements.push(this.sideElements[key]);

            return elements.length * 1;
        },
        zIndexesFix: function () {
            let elements = [];
            for (var key in this.sideElements)
                if (this.sideElements[key] !== null &&
                    this.sideElements[key].side === this.side &&
                    this.sideElements[key].language === this.language &&
                    this.sideElements[key].component !== 'image-area')
                    elements.push(this.sideElements[key]);
            elements.sort((a, b) => {
                return a.zIndex - b.zIndex;
            });

            for (var key in elements)
                elements[key].zIndex = key * 1;
        },
    },
    mounted: function () {
        // Process model data
        if (this.value)
            this.$set(this, 'sideElements', this.value);

        // Fix the zIndexes
        this.zIndexesFix();

        this.sideHeight = this.$refs.container.offsetHeight;
        this.sideWidth = this.$refs.container.offsetWidth;

        // Update mounted status
        this.mounted = true;
        setTimeout(this.resizeScreen, 200);
        window.addEventListener('resize', this.resizeScreen);

        // Listen to keys
        document.addEventListener('keydown', this.keyDown)
        document.addEventListener('keyup', this.keyUp)

    },
    props: {
        editable: {
            default: false,
            required: false,
            type: Boolean,
        },
        editMode: {
            default: 'user',
            required: false,
            type: String,
        },
        enableDelete: {
            default: true,
            required: false,
            type: Boolean,
        },
        enableImages: {
            default: true,
            required: false,
            type: Boolean,
        },
        enableStickers: {
            default: true,
            required: false,
            type: Boolean,
        },
        enableTextareas: {
            default: true,
            required: false,
            type: Boolean,
        },
        enableTexts: {
            default: true,
            required: false,
            type: Boolean,
        },
        enableZIndexes: {
            default: true,
            required: false,
            type: Boolean,
        },
        flipped: {
            default: false,
            required: false,
            type: Boolean,
        },
        format: {
            default: 'a5-landscape',
            required: false,
            type: String,
        },
        language: {
            default: 'en',
            required: false,
            type: String,
        },
        parentState: {
            default: null,
            type: String,
            required: false,
        },
        side: {
            required: true,
            type: String,
        },
        value: {
            default: () => [],
            required: false,
            type: Array,
        },
    },
    watch: {
        parentState: {
            handler: function (newVal, oldVal) {
                if (newVal !== null &&
                    this.selected !== null)
                    this.deselect(this.selected);
                if (newVal !== null)
                    this.setState(null);
            },
        },
        sideElements: {
            deep: true,
            handler: function (newVal, oldVal) {
                this.$emit('input', newVal);
            },
        },
        value: {
            deep: true,
            handler: function (newVal, oldVal) {
                this.$set(this, 'sideElements', newVal);
            },
        },
    },
}
</script>

<style>
.flipped {
    transform: rotateY(-180deg);
    transform-origin: 50% 50%;
}

.side-container:hover .drr {
    border: none !important;
    outline-style: dashed;
    outline-width: 2px;
}

.drr:hover:before {
    background: rgba(0, 0, 0, 0.1);

    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    outline: none !important;
}

.drr-stick {
    z-index: 50;
}

.active,
.content-active {
    border: none !important;
    outline-style: solid !important;
    outline-width: 2px !important;
}

.drr.active:before {
    border: none !important;
    outline: none !important;
}

#side-controls-in .ProseMirror {
    color: #000000 !important;

}

#side-controls-in .ProseMirror * {
    color: #000000 !important;
}
</style>